import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Radio, Form, Input, message, Button, DatePicker,Select, Cascader } from "antd";
import moment from 'moment'
import editIcon from "../../assets/pencil.png";
import { CloseOutlined } from "@ant-design/icons";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import useJDStore from "../../store/jd.store";
import useMembersStore from "../../store/members.store";
import {ROLE_OPTIONS, ROLE_TYPE_OPTIONS, SUPPORTED_JOB_CATEGORY, SUPPORTED_LOCATION, WORK_OPTIONS} from "../../helper/categoryconstants" 
import "./jdCreationForm.scss";
import { Space } from "antd";

export default function JDCreationForm({nujobsPost=false, setCurrentView }) {
    const [isEditMode, setIsEditMode] = useState(false);
    const [formKey, setFormKey] = useState(1);

    const [jobCategory, setJobCategory] = useState("IT");
    const [jobRole, setJobRole] = useState("Developer");
    const [form] = Form.useForm();
    
    const navigate = useNavigate();
    const { value } = useParams();
    const { createJd, updateJd,selectedJD,clearJD,refreshJDFlag,resetJDRefreshFlag,getJdByID,jdUpdatedFlag,resetJDUpdatedFlag} = useJDStore();
    const { getVendors, getTeamMembers, getAssignedMembers } = useMembersStore();
    const { clients } = useMembersStore();
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const bStream = [
        { value: 'any',label:'Any'},
        { value: 'it', label: 'IT'},
        { value: 'computers', label: 'Computers' },
        { value: 'electronics', label: 'Electronics' },
        { value: 'electrical', label: 'Electrical'},
        { value: 'civil', label: 'Civil' },
        { value: 'mechanical', label: 'Mechanical' }, 
        { value: 'metallurgy', label: 'Metallurgy' }      
      ];
      
       const bDegrees = [
        { value: 'btech', label: 'BE/BTech',children: bStream},
        { value: 'bca', label: 'BCA' },
        { value: 'bcom', label: 'BCom'},
        { value: 'bpharma', label: 'Bpharma' },
        { value: 'bsc', label: 'BSc' }, 
        { value: 'bs', label: 'BS' },
        { value: 'any', label: 'Any' },      
      ];
      
      const mDegrees = [
        { value: 'mtech', label: 'ME/MTech',children: bStream},
        { value: 'mca', label: 'MCA' },
        { value: 'mcom', label: 'MCom'},
        { value: 'mpharma', label: 'Mpharma' },
        { value: 'msc', label: 'MSc' }, 
        { value: 'ms', label: 'MS' },
        { value: 'any', label: 'Any' }       
      ];
      
      const medicalDegrees = [
        { value: 'mbbs', label: 'MBBS',children: bStream},
        { value: 'md', label: 'MS/MD' },
        { value: 'any', label: 'Any'}     
      ];
      
      const businessDegrees = [
        { value: 'mba', label: 'MBA',children: bStream},
        { value: 'bba', label: 'BBA' },
        { value: 'any', label: 'Any'}     
      ];
       const educationList = [
        { value: 'Bachelors', label: 'Bachelors',children: bDegrees},
        { value: 'Masters', label: 'Masters', children: mDegrees },
        { value: 'Medical', label: 'Medical', children: medicalDegrees },
        { value: 'Business', label: 'Business', children: businessDegrees},
        { value: 'Diploma', label: 'Diploma' },
        { value: 'Phd', label: 'Phd' },           
      ];


    const onCategoryChange = (val) => {
        setJobCategory(val);
        console.log("category change--",val,ROLE_OPTIONS[val]?.[0]?.value)
        setJobRole( ROLE_OPTIONS[val]?.[0]?.value)
        form.setFieldValue({ role: null });
    };  
   const onJobRoleChange = (val) => {
        setJobRole( val)
    }; 

    const [jdValues, setJdValues] = useState({});  
    const [reqType, setReqType] = useState("customer_project");  
    const [ctcType, setCTCType] = useState("normal");        
    const [deriveKeyWordsFromAI, setDeriveKeyWordsFromAI] = useState(true);   
    const [usedKeywords, setUsedKeyWords] = useState("");          
    const [formMargin, setMargin] = useState(0);  
    const [formFinalBillRate, setFinalBillRate] = useState(0); 
    const [formMaxDerivedCTC, setMaxDerivedCTC] = useState(0); 
    const [formClientName, setformClientName] = useState(""); 
    const [formTaName, setformTaName] = useState("");     
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    const getValueForCascaderClient =(client,TA) =>{
        const str = client +','+ TA;
        const arr = str.split(","); 
        return arr
    }
    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }   
        
    const initJDParams = () =>{
        var jdValuesTmp
        if (value !== undefined) {
            //console.log("Selected JD", selectedJD)
            setJobCategory(selectedJD?.JDDetails.JobCategory)
            setJobRole(selectedJD?.JDRequired.Role)
            setDeriveKeyWordsFromAI(selectedJD?.useaigenkeywords? true:false)
            setUsedKeyWords(selectedJD?.useaigenkeywords?selectedJD?.jdfinalderivedskills:selectedJD?.jdanuallyaddedskills)
            jdValuesTmp = {
                bu_name: selectedJD?.JDProject.BuName,
                proj_name: selectedJD?.JDProject.ProjectName,
                job_category: selectedJD?.JDDetails.JobCategory,
                job_permission: selectedJD?.JDDetails.JobPermission,
                title: selectedJD?.JDDetails.Title,
                req_type: selectedJD?.JDProject.ReqType,
                ctc_type: selectedJD?.JDProject.CTCType,
                client_name: getValueForCascaderClient(selectedJD?.JDClient.ClientName,selectedJD?.JDClient.TaName),
                ta_name: selectedJD?.JDClient.TaName,
                end_client_name: selectedJD?.JDClient.EndClient,
                client_job_type: selectedJD?.JDClient.ClientJobType,
                job_type: selectedJD?.JDDetails.JobType,
                job_time: selectedJD?.JDDetails.JobTime,
                designation: selectedJD?.JDDetails.Designation,
                roles_and_responsibility: selectedJD?.JDRequired.RoleDetails,
                roletype: selectedJD?.JDRequired.RoleType,
                role: selectedJD?.JDRequired.Role,
                skills: selectedJD?.JDRequired.Skills,
                keywords: selectedJD?.useaigenkeywords?selectedJD?.jdfinalderivedskills:selectedJD?.jdanuallyaddedskills,
                useaigenkeywords: selectedJD?.useaigenkeywords,
                jdfinalderivedskills: selectedJD?.jdfinalderivedskills,
                soft_skills: selectedJD?.soft_skills,
                education: selectedJD?.JDRequired.Education,
                finalbillrate:selectedJD?.JDProject.FinalBillRate,
                margin:selectedJD?.JDProject.Margin,
                maxctclpm:selectedJD?.JDProject.MaxCTCLPM,
                min_ctc: selectedJD?.JDProject.MinCtc,
                max_ctc: selectedJD?.JDProject.MaxCtc,
                postingdate: selectedJD?.JDOther.PostingDate,
                postedby: selectedJD?.JDOther.PostedBy,
                priority: selectedJD?.JDOther.Priority,
                number_of_positions: selectedJD?.JDProject.NumPositions,
                valid_until: moment(selectedJD?.JDOther.ValidUntil),
                work_location: selectedJD?.JDRequired.WorkLocation,
                work_mode: selectedJD?.JDRequired.WorkMode,
                diversity_only: selectedJD?.JDRequired.Diversity,
                freshers_only: selectedJD?.JDRequired.Fresher,
                interns_only: selectedJD?.JDRequired.Interns,
                premiuminstitute_only: selectedJD?.JDRequired.PremiumInstituteOnly,
                premiumjob: selectedJD?.JDRequired.PremiumJob,   
                hidectc:selectedJD?.JDRequired.HideCtc,                                                                       
                notice_period: selectedJD?.JDRequired.NoticePeriod,
                min_exp: selectedJD?.JDRequired.MinExperience,
                max_exp: selectedJD?.JDRequired.MaxExperience,
                hm_name: selectedJD?.HmName,
                hm_email: selectedJD?.HmEmail,
                hm_number: selectedJD?.HmNumber,
                allow_nonsuitable: selectedJD?.JDOther.AllowNonSuitable,
                non_suitable_allow_reason: selectedJD?.JDOther.AllowNonSuitableReason,  
                updatedon: formatUnixDate(selectedJD?.timestamp),
                updatedby: selectedJD?.updatedby,             
            };
            //console.log("JD Tmp", jdValuesTmp)
            setReqType(jdValuesTmp?.req_type);  
            setCTCType(jdValuesTmp?.ctc_type);          
            setMargin(jdValuesTmp?.margin);  
            setFinalBillRate(jdValuesTmp?.finalbillrate); 
            setMaxDerivedCTC(jdValuesTmp?.maxctclpm);    
            setformClientName(selectedJD?.JDClient.ClientName)
            setformTaName(selectedJD?.JDClient.TaName)          
            setJdValues(jdValuesTmp)
            form.setFieldsValue(jdValuesTmp);
        }
    }

    //selected jd from table
    useEffect(() => {
        //console.log("Calling Refresh UseEffect", value,refreshJDFlag )
        if((value !== undefined) && (refreshJDFlag)){ 
            resetJDRefreshFlag()
            initJDParams();            
            //console.log("Select JD",value,selectedJD)
        }     
        setFormKey((prevKey) => prevKey + 1);
        
        //console.log("Exit Flag Based useEffet")
    }, [refreshJDFlag]);
    
    //for createjd and local view changes
    useEffect(() => {
        //console.log("Calling Init UseEffect", value,refreshJDFlag )
        if ((value !== undefined) && (!refreshJDFlag)) {
            const fetchData = async (value) => {
                try {
                        getJdByID(value);
                        getVendors();
                        getTeamMembers();
                        getAssignedMembers(value);
                } catch (error) {
                  console.error("Error fetching data:", error);
                }
              };
              fetchData(value);  
        } else {
            //console.log("clearing JD and selected mode",selectedJD);
            setIsEditMode(true)
            clearJD()
            setJdValues({})
        }
    }, []);

        //selected jd from table
    useEffect(() => {
        if((value !== undefined) && (!refreshJDFlag)&&(jdUpdatedFlag)){ 
            const fetchData = async (value) => {
                try {
                    getJdByID(value);
                    //setIsJDUpdated(false)
                    resetJDUpdatedFlag()
                } catch (error) {
                  console.error("Error fetching data:", error);
                }
              };
              fetchData(value);
              setCurrentView("assignment");  
        }else{
           //setIsJDUpdated(false) 
           resetJDUpdatedFlag()
        }     
        //console.log("Exit Flag Based useEffet")
    }, [jdUpdatedFlag]);

    //dont render until we have updated result
    if((value !== undefined) && (refreshJDFlag)) return;

    var clientTADB = clients?.map((client, idx) => {
        var tL =client?.ClientTAList 
        //get the TA list for each
        var taListDB = tL?.map((ta, idx) => {
            return {
            value:ta?.TAName,
            label:ta?.TAName,
            };
       });
        return {
          value:client?.ClientName,
          label:client?.ClientName,
          children:taListDB
        };
    })    
    const handleClientandTA =(val) => {
         console.log('Value', val);
         //console.log('Client and TA Option Cient DB Array', clientTADB);
         setformClientName(val[0])
         setformTaName(val[1])
         //jdValues.client_name = val[0]
         //jdValues.ta_name = val[1]
         //console.log("Selected Client and TA",jdValues.client_name, jdValues.ta_name);
    }
    const getMaxCTCLpm =(rate, margin) => {
         //console.log('Rate, margin', rate,margin);
         var maxCTCLPM,marginFraction
         marginFraction = margin / 100
         maxCTCLPM = rate / (1+ marginFraction)
         return maxCTCLPM.toFixed(2)         
    }
  
    const handleMargin = (e) => {    
        setMargin(e.target.value)
        setMaxDerivedCTC(getMaxCTCLpm(formFinalBillRate,e.target.value))
    };
    const handleFinalBillRate = (e) => {      
        setFinalBillRate(e.target.value)
        setMaxDerivedCTC(getMaxCTCLpm(e.target.value,formMargin))
    };

    const onChange = (e) => {      
        setReqType(e.target.value)
      };

    const onChangeDerivedCTC = (e) =>{
        setCTCType(e.target.value)
    }
    const onChangeUseAIGeneratedKeywords = (e) =>{  
        var currentValue = e.target.value?selectedJD?.jdfinalderivedskills:selectedJD?.jdanuallyaddedskills
        setDeriveKeyWordsFromAI(e.target.value)
        setUsedKeyWords(currentValue)
        form.setFieldsValue({
            keywords: currentValue || "",
        });
    }
    const onChangeEducation = (value) => {
        console.log(value);
      };

      function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }

    const encodeJson = (values,action) =>{

        let encodedJsonValues ={};

        //console.log("data to encode", values)
        //FSM to maintain the JD state
        if(action === "NEW"){
            encodedJsonValues.jdstate= "Unassigned";
        }
        //get company details
        encodedJsonValues.qhoid= userData.qhoid;
        encodedJsonValues.accounttype= userData.account_type;
        encodedJsonValues.companyname = userData.organization

        //now fill the parameters
        encodedJsonValues.jdproject ={};
        encodedJsonValues.jdproject.reqtype=reqType;
        encodedJsonValues.jdproject.buName=values.bu_name;
        encodedJsonValues.jdproject.projectName=values.proj_name;
        encodedJsonValues.jdproject.reqStatus="Active";
        encodedJsonValues.jdproject.HmName=values.hm_name;
        encodedJsonValues.jdproject.HmEmail=values.hm_email;
        encodedJsonValues.jdproject.hmNumber=values.hm_number;
        encodedJsonValues.jdproject.NumPositions= parseInt(values.number_of_positions);
        encodedJsonValues.jdproject.minctc= Number(parseFloat(values.min_ctc).toFixed(2));
        if(ctcType === "normal"){
           encodedJsonValues.jdproject.maxctc= Number(parseFloat(values.max_ctc).toFixed(2));
        } else{
        encodedJsonValues.jdproject.maxctc= Number((parseFloat(formMaxDerivedCTC)*12).toFixed(2))
        }           
        encodedJsonValues.jdproject.ctctype= ctcType; 
        encodedJsonValues.jdproject.finalbillrate= parseFloat(formFinalBillRate); 
        encodedJsonValues.jdproject.margin= parseFloat(formMargin);
        encodedJsonValues.jdproject.maxctclpm= Number(parseFloat(formMaxDerivedCTC).toFixed(2));

        encodedJsonValues.jddetails ={};
        encodedJsonValues.jddetails.Title= values.title;
        encodedJsonValues.jddetails.JobPermission=values.job_permission; // private protected public
        encodedJsonValues.jddetails.JobTime=values.job_time; // full time, part time
        encodedJsonValues.jddetails.JobType=values.job_type; // permanent, contract
        encodedJsonValues.jddetails.JobCategory=values.job_category; // many types
        encodedJsonValues.jddetails.Designation=values.designation;
        encodedJsonValues.jddetails.Role=values.designation;
    
        encodedJsonValues.jdrequired ={};
        encodedJsonValues.jdrequired.Skills= values.skills;
        encodedJsonValues.jdrequired.RoleDetails= values.roles_and_responsibility;
        encodedJsonValues.jdrequired.Role= values.role;
        encodedJsonValues.jdrequired.RoleType= values.roletype;
        encodedJsonValues.jdrequired.Keywords= values.keywords;
        encodedJsonValues.useaigenkeywords= deriveKeyWordsFromAI;
        encodedJsonValues.jdfinalderivedskills= values.jdfinalderivedskills;
        encodedJsonValues.jdrequired.Education= values.education;
        encodedJsonValues.jdrequired.NoticePeriod= parseInt(values.notice_period); //int
        if(encodedJsonValues.jdrequired.NoticePeriod ==0){
             encodedJsonValues.jdrequired.ImmediateJoiners = true
        }
        
        encodedJsonValues.jdrequired.MinExperience= parseInt(values.min_exp);
        encodedJsonValues.jdrequired.MaxExperience= parseInt(values.max_exp);        
        encodedJsonValues.jdrequired.WorkLocation= values.work_location;
        if ( encodedJsonValues.jdrequired.WorkLocation.includes("Pan India")){
            encodedJsonValues.jdrequired.IsPanIndia = true
        }

        encodedJsonValues.jdrequired.Country= "India";
        encodedJsonValues.jdrequired.WorkMode= values.work_mode;
        encodedJsonValues.jdrequired.Diversity= values.diversity_only; //bool
        encodedJsonValues.jdrequired.Fresher= values.freshers_only; //bool
        encodedJsonValues.jdrequired.Interns= values.interns_only; //bool
        encodedJsonValues.jdrequired.PremiumInstituteOnly= values.premiuminstitute_only; //bool
        encodedJsonValues.jdrequired.PremiumJob= values.premiumjob; //bool
        
        encodedJsonValues.jdnujobs = {}
        encodedJsonValues.jdnujobs.HideCTC= values.hidectc; //bool

                    
        //not assigned yet
        encodedJsonValues.jdassignment =null;
        
        encodedJsonValues.jduseraction ={};
        encodedJsonValues.jduseraction.isFavourite = false;//bool
        encodedJsonValues.jduseraction.colorCode="";

        encodedJsonValues.jdclient ={};

        if(reqType === "customer_project"){
            encodedJsonValues.jdclient.ClientName =  formClientName
            encodedJsonValues.jdclient.TaName = formTaName;
            encodedJsonValues.jdclient.EndClient =values.end_client_name;
            encodedJsonValues.jdclient.ClientJobType=values.client_job_type;   
        }else{
            encodedJsonValues.jdclient.clientName = "Internal";
            encodedJsonValues.jdclient.TaName = userData.username;;
        }
        //not assinged yet
        //encodedJsonValues.jdclient.taName      ="";
        //encodedJsonValues.jdclient.taContact   ="";
        //encodedJsonValues.jdclient.taMail      ="";
        
        //encodedJsonValues.jdvendorconnect =[];
        //let vendorDetails ={}
        //vendorDetails.qhVID= "";
	    //vendorDetails.vendorName ="";
        //encodedJsonValues.jdvendorconnect.push(vendorDetails);        
        encodedJsonValues.jdother ={}; 
        encodedJsonValues.jdother.valid_until = values.valid_until;
        if(values.allow_nonsuitable ==true){
           encodedJsonValues.jdother.AllowNonSuitable = true;
        } else{
           encodedJsonValues.jdother.AllowNonSuitable = false;
        }
        encodedJsonValues.jdother.AllowNonSuitableReason = values.non_suitable_allow_reason;
        
        //get the current date
        let newDate = getTimeNow()
        if(action === "NEW"){
            encodedJsonValues.jdother.postingDate= newDate;
            encodedJsonValues.jdother.postedby    = userData.username;
            encodedJsonValues.jdother.qhuid    = userData.qhuid;
        }
        encodedJsonValues.jdother.priority    = values.priority;        
        //no resume added
        encodedJsonValues.resumelist = null;             
        return encodedJsonValues
    }

  const handleFormSubmit = async (values) => {
    const jasonValues = encodeJson(values, "NEW");

    try {
      const jdID = await createJd({
        ...jasonValues,
      });
      message.success("New JD Created");
      if(nujobsPost){
        navigate(`/jds/${jdID}/nujobs`, { state: { newView: "assignment" } });
      }else{
        navigate(`/jds/${jdID}`, { state: { newView: "assignment" } });
      }
    } catch (err) {
      message.error("Failed to create JD. Please try again.");
      console.error("Error during JD creation:", err);
    }
  };

  const handleUpdateFormSubmit = async (values) => {
    const jasonValues = encodeJson(values,"UPDATE");
    try {
           await updateJd({
            ...jasonValues
          },value);
          message.success("JD Updated Successfully");
          //navigate(`/jds/${value}`, { state: { newView: "assignment" } });
          setIsEditMode(false);
          //setIsJDUpdated(true)          
    } catch (err) {
          message.error("Failed to update JD. Please try again.");
          console.error("Error during JD creation:", err);
    }
   };
     
 
    return (
        <div className="jd-creation-form-wrapper">
            <div className="header">
                {isEditMode ?
                   value? <h3 className="jd-creation-form-title">Edit JD</h3> 
                   :<h3 className="jd-creation-form-title">Creating New JD</h3>  :
                              <h3 className="jd-creation-form-title">JD (Read Only)</h3>  }
                {deriveKeyWordsFromAI?<>✨AI Assisted✨</>:<></>}
                {!isEditMode && value? (
                    <Button
                    className="jd-creation-edit-button"
                    onClick={() => setIsEditMode(true)}
                    type="primary"
                    >
                    <img src={editIcon} alt="Edit" width="14" height="14" />
                    </Button>
                ) : value?(
                    <Button
                    className="jd-creation-edit-button"
                    onClick={() => setIsEditMode(false)}
                    >
                    <CloseOutlined /> Cancel
                    </Button>
                ):<></>}                
            </div>
            <Form
                form = {form}
                key={formKey}
                className="jd-creation-form"
                justify="start"
                layout="vertical"
                autoComplete="off"
                onFinish={value ? handleUpdateFormSubmit : handleFormSubmit}
                initialValues={jdValues}
>
                <Form.Item
                    required={true}
                    className="jd-creation-field-item"
                    label="Job Title"
                    name="title"
                >
                    <Input
                        disabled={!isEditMode}
                        required={ true}
                        placeholder={"Enter the JD Title "}
                        className="jd-creation-input"
                    />
                </Form.Item>

                <Form.Item
                    required={true}
                    className="jd-creation-field-item"
                    name="req_type"
                    label="Requirement Type"
                >
                    <Radio.Group
                        disabled={!isEditMode}
                        className="jd-creation-radio-wrapper"
                        onChange={onChange}
                        required={true}
                        defaultValue={reqType}
                    >
                        <Radio
                            className="radio-option"
                            value="internal_project"
                        >
                            Internal Requirements
                        </Radio>
                        <Radio
                            className="radio-option"
                            value="customer_project"
                        >
                            Customer Requirements
                        </Radio>
                    </Radio.Group>
                </Form.Item>

                {(reqType === "internal_project")?
                    <></>
                    :
                    <>
                        <div className="triple-input-wrapper">
                        <Form.Item
                            rules={[
                                { required: true, message: 'Please select Client and TA name!' }
                            ]}  
                            className="jd-creation-field-item"
                            label="Client/TA Name"
                            name="client_name"
                        >                        
                        <Cascader
                             disabled={!isEditMode}
                             size="small"
                             className="jd-creation-input"  
                             options={clientTADB} 
                             onChange={handleClientandTA}
                             placeholder="Please select" 
                        />   
                            
                        </Form.Item>
                        <Form.Item
                        rules={[
                                { required: true, message: 'Please select Client Job Type!' }
                            ]}  
                        className="jd-creation-field-item"
                        label="Client Job Type"
                        name="client_job_type"
                        >
                            <Select
                                    disabled={!isEditMode}
                                    size="small"
                                    required={true}
                                    className="jd-creation-input"                            
                                    placeholder="Please Select"
                                    options={[
                                        { value: 'FTE', label: 'FTE' },
                                        { value: 'TP', label: 'TP' },
                                    ]}
                            />                        
                        </Form.Item>                        
                        <Form.Item
                                required={true}
                                name="end_client_name"
                                className="jd-creation-field-item"
                                label="End Client"
                            >
                            <Input
                                disabled={!isEditMode}
                                required={true}
                                className="jd-creation-input"
                            />    
                        </Form.Item>
                        </div>                                          
                    </>
                }

                <div className="dual-input-wrapper">
                    <Form.Item
                        rules={[
                            { required: true, message: 'Please select Job Category!' }
                        ]}   
                        className="jd-creation-field-item"
                        label="Job Category"
                        name="job_category"
                    >
                            <Select
                                disabled={!isEditMode}
                                required={true}
                                size="small"
                                className="jd-creation-input"                            
                                placeholder="Please select"
                                onChange={onCategoryChange}
                                options={SUPPORTED_JOB_CATEGORY}
                            />                         
                    </Form.Item>
                    <Form.Item
                            rules={[
                                    { required: true, message: 'Please select Job Permission!' }
                            ]}                            
                            name="job_permission"
                            className="jd-creation-field-item"
                            label="Job Permission"
                        >
                            <Select
                                disabled={!isEditMode}
                                required={true}
                                placeholder="Please select"
                                className="jd-creation-input"                            
                                options={nujobsPost === false?[
                                    { value: 'Private', label: 'Private' },
                                    { value: 'Public', label: 'Public' },
                                    { value: 'Protected', label: 'Protected' },
                                ]:[
                                    { value: 'Private', label: 'Private' },
                                    { value: 'Public', label: 'Public' },
                                ]}
                            />                            
                    </Form.Item>
                </div>

                <div className="dual-input-wrapper">
                    <Form.Item
                        rules={[
                                { required: true, message: 'Please select Job Type!' }
                        ]}
                        className="jd-creation-field-item"
                        label="Job Type"
                        name="job_type"
                    >
                    <Select
                            disabled={!isEditMode}
                            className="jd-creation-input"                            
                            placeholder="Please Select"
                            options={[
                                  { value: 'Permanent', label: 'Permanent' },
                                  { value: 'Contract', label: 'Contract' },
                            ]}
                    />                        
                    </Form.Item>
                    <Form.Item
                            rules={[
                                { required: true, message: 'Please select Job Time!' }
                            ]}
                            name="job_time"
                            className="jd-creation-field-item"
                            label="Job Time"
                        >
                        <Select
                            disabled={!isEditMode}
                            size="small"
                            className="jd-creation-input"                            
                            placeholder="Please Select"
                            options={[                        
                                  { value: 'Full Time', label: 'Full Time' },
                                  { value: 'Part Time', label: 'Part Time' },
                            ]}
                        />  
                    </Form.Item>
                </div>
                <div className="triple-input-wrapper">
                    <Form.Item
                        rules={[
                            { required: true, message: 'Please select Priority!' }
                        ]}
                        name="priority"
                        className="jd-creation-field-item"
                        label="Job Priority"
                    >
                        <Select
                            disabled={!isEditMode}
                            size="small"
                            className="jd-creation-input"                            
                            placeholder="Please Select"
                            options={[
                                  { value: 'High', label: 'High' },
                                  { value: 'Normal', label: 'Normal' },
                                  { value: 'Low', label: 'Low' },
                                  { value: 'Urgent', label: 'Urgent' },
                                  { value: 'Todays', label: 'Todays' },                                                                  
                            ]}
                        />                          
                    </Form.Item>

                    <Form.Item
                        name="number_of_positions"
                        className="jd-creation-field-item"
                        label="Number of Positions"
                    >
                        <Input
                            disabled={!isEditMode}
                            type="text"                            
                            className="jd-creation-input"
                        />
                    </Form.Item>
                    <Form.Item
                        name="valid_until"
                        className="jd-creation-field-item"
                        label="JD Validity"
                    >
                        <DatePicker
                            style={{ width: "100%" }}
                            disabled={!isEditMode}
                            className="jd-creation-input"
                        />
                    </Form.Item>
                </div>

                <div className="triple-input-wrapper">
                    <Form.Item
                            required={true}
                            name="designation"
                            className="jd-creation-field-item"
                            label="Designation"
                        >
                            <Input
                                disabled={!isEditMode}
                                required={ true}
                                className="jd-creation-input"
                            />
                    </Form.Item> 
                    <Form.Item
                        rules={[
                            { required: true, message: 'Please select role type!' }
                        ]}
                        name="roletype"
                        className="jd-creation-field-item"
                        label="Role Type"
                    >
                        <Select
                            disabled={!isEditMode}
              size="small"
                            required={true}
                            className="jd-creation-input"                            
                            options={ROLE_TYPE_OPTIONS}
                        /> 
                    </Form.Item>   
                    <Form.Item
                        rules={[
                            { required: true, message: 'Please select a role!' }
                        ]}
                        name="role"
                        className="jd-creation-field-item"
                        label="Role"
                    >
                        <Select
                            disabled={!isEditMode}
              size="small"
                            onChange={onJobRoleChange}
                            value = {jobRole}
                            className="jd-creation-input"                            
                            options={ROLE_OPTIONS[jobCategory]}                            
                        /> 

                    </Form.Item>                   
                </div>

                <Form.Item
                    required={true}
                    name="roles_and_responsibility"
                    className="jd-creation-field-item"
                    label="Roles & Responsibility of the job"
                >
                        <ReactQuill
                            theme="snow"
                            readOnly={!isEditMode}
                            value={form.getFieldValue("roles_and_responsibility") || ""}
                            onChange={(value) => {
                                form.setFieldValue("roles_and_responsibility", value);
                            }}
                        /> 
                </Form.Item>
                <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please enter required skills",
                            },
                        ]}
                        name="skills"
                        className="jd-creation-field-item"
                        label="Required skills "
                >
                        <ReactQuill
                            theme="snow"
                            readOnly={!isEditMode}
                            value={form.getFieldValue("skills") || ""}
                            onChange={(value) => {
                                form.setFieldValue("skills", value);
                            }}
                        />                
                </Form.Item>
                {
                    nujobsPost === false?
                    <>
                        <Form.Item
                            required={true}
                            className="jd-creation-field-item"
                            name="useaigenkeywords"
                            label="Use AI Generated Keywords"
                        >
                            <Radio.Group
                                disabled={!isEditMode}
                                defaultValue={deriveKeyWordsFromAI}
                                className="jd-creation-radio-wrapper"
                                onChange={onChangeUseAIGeneratedKeywords}
                                required={true}
                            >
                                <Radio
                                    className="radio-option"
                                    value={true}
                                >
                                    Yes
                                </Radio>
                                <Radio
                                    className="radio-option"
                                    value={false}
                                >
                                    No
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                        {   deriveKeyWordsFromAI === true?
                            <>
                                {
                                    value?
                                    <>
                                        <Form.Item
                                                name="jdfinalderivedskills"
                                                className="jd-creation-field-item"
                                                label={
                                                    <span style={{ color: "#007bff", marginRight: 6 }}>
                                                        ✨ AI Generated Keywords ✨ 
                                                    </span>
                                                }
                                            >
                                                <span
                                                    style={{
                                                        padding: "8px 12px",
                                                        fontSize: "12px",
                                                        fontWeight: 500,
                                                        width: "100%",
                                                    }}
                                                >
                                                    {usedKeywords}
                                                </span>          
                                        </Form.Item>                              
                                    </>
                                    :<>
                                    </>
                                }                    
                            </>
                            :
                            <>
                                <Form.Item
                                        required={true}
                                        name="keywords"
                                        className="jd-creation-field-item"
                                        label="Keyword Tags"
                                    >
                                        <Input
                                            disabled={!isEditMode}
                                            required={value ? false : true}
                                            className="jd-creation-input"
                                            placeholder={usedKeywords}
                                            
                                        />
                                </Form.Item>                      
                            </>
                        }                    
                    </>
                    :<>
                        <Form.Item
                                        required={true}
                                        name="keywords"
                                        className="jd-creation-field-item"
                                        label="Keyword Tags"
                                    >
                                        <Input
                                            disabled={!isEditMode}
                                            required={value ? false : true}
                                            className="jd-creation-input"
                                            placeholder={usedKeywords}
                                        />
                        </Form.Item>                      
                     
                    </>
                }
                {(reqType === "internal_project")?
                  <> 
                  </>
                  :<>
                        <Form.Item
                            required={true}
                            className="jd-creation-field-item"
                            name="ctc_type"
                            label="Derive CTC From Margin"
                        >
                            <Radio.Group
                                disabled={!isEditMode}
                                defaultValue={ctcType}
                                className="jd-creation-radio-wrapper"
                                onChange={onChangeDerivedCTC}
                                required={true}
                            >
                                <Radio
                                    className="radio-option"
                                    value="derived"
                                >
                                    Yes
                                </Radio>
                                <Radio
                                    className="radio-option"
                                    value="normal"
                                >
                                    No
                                </Radio>
                            </Radio.Group>
                        </Form.Item>                 
                  </>
                }

                {ctcType === "normal"?
                    <></>
                    :
                    <>
                        <div className="triple-input-wrapper">
 
                        <Form.Item
                        required={true}
                        className="jd-creation-field-item"
                        label="Final Bill Rate (LPM) "
                        name="finalbillrate"
                        >
                            <Input
                                disabled={!isEditMode}
                                required={true}
                                onChange = {handleFinalBillRate}
                                className="jd-creation-input"
                            />                       
                        </Form.Item>                        
                        <Form.Item
                                required={true}
                                name="margin"
                                className="jd-creation-field-item"
                                label="Margin %"
                            >
                            <Input
                                disabled={!isEditMode}
                                required={true}              
                                onChange = {handleMargin}                  
                                className="jd-creation-input"
                            />    
                        </Form.Item>
                        <Form.Item
                                required={true}
                                className="jd-creation-field-item"
                                label="Max CTC LPM"
                            >
                            <Input
                                disabled={true}
                                required={true}
                                value = {formMaxDerivedCTC}
                                className="jd-creation-input"
                            />    
                        </Form.Item>                        
                        </div>                                          
                    </>
                }

                <div className="triple-input-wrapper">
                    <Form.Item
                        className="jd-creation-field-item"
            label="Experience Range (Yrs) "
            required={true}
          >
            <Space style={{ display: "flex", gap: "8px" }}>
              <Form.Item
                required={true}
                className="jd-creation-field-item"
                name="min_exp"
              >
                <Input
                  disabled={!isEditMode}
                  type="number"
                  required={ true}
                  className="jd-creation-input"
                  placeholder="Min"
                />
              </Form.Item>
              <Form.Item
                required={true}
                className="jd-creation-field-item"
                name="max_exp"
              >
                <Input
                  disabled={!isEditMode}
                  type="number"
                  required={true}
                  className="jd-creation-input"
                  placeholder="Max"
                />
              </Form.Item>
            </Space>
          </Form.Item>
          <Form.Item
            className="jd-creation-field-item"
            label="Offered CTC (LPA)"
            required={true}
          >
            <Space>
              <Form.Item
                name="min_ctc"
                className="jd-creation-field-item"
              >
                <Input
                  disabled={!isEditMode}
                  type="number"
                  required={true}
                  className="jd-creation-input"
                  placeholder="Min"
                />
              </Form.Item>
              {
                ctcType === "normal"?
                <>
                    <Form.Item
                        required={true}
                        name="max_ctc"
                        className="jd-creation-field-item"
                    >
                        <Input
                        disabled={!isEditMode}
                        type="number"
                        required={true}
                        className="jd-creation-input"
                        placeholder="Max"
                        />
                    </Form.Item>
                </>
                :<>
                    <Form.Item
                        required={true}
                        className="jd-creation-field-item"
                    >
                        <Input
                        disabled={true}
                        required={true}
                        className="jd-creation-input"
                        value={(parseFloat(formMaxDerivedCTC)*12).toFixed(2)}
                        />
                    </Form.Item>                
                </>
              }
            </Space>
          </Form.Item>
                    <Form.Item
                        required={true}
                        className="jd-creation-field-item"
                        label="Notice Period (Days)"
                        name="notice_period"
                    >
                        <Input
                            disabled={!isEditMode}
                            type="number"
                            required={true}
                            className="jd-creation-input"
                        />
                    </Form.Item>
                </div>

                <div className="triple-input-wrapper">
                    <Form.Item
                        required={true}
                        name="education"
                        className="jd-creation-field-item"
                        label="Education"
                    >
                        <Cascader 
                            disabled={!isEditMode}
                            size="small"
                            maxTagCount={4}
                            required={true}
                            className="jd-creation-input"   
                            options={educationList} 
                            onChange={onChangeEducation} 
                            placeholder="Please Select"
                            multiple
                        />                                                
                    </Form.Item>  

                    <Form.Item
                        rules={[
                                    { required: true, message: 'Please select Work Location!' }
                        ]}   
                        name="work_location"
                        className="jd-creation-field-item"
                        label="Work Location"
                    >
                            <Select
                                disabled={!isEditMode}
                                size="small"
                                maxTagCount={4}
                                placeholder="Please Select"
                                className="jd-creation-input"
                                mode="multiple"
                                allowClear                                                 
                                options={SUPPORTED_LOCATION}
                            />                         
                    </Form.Item>   


                    <Form.Item
                        rules={[
                                    { required: true, message: 'Please select Job Permission!' }
                        ]}                           
                        name="work_mode"
                        className="jd-creation-field-item"
                        label="Work Mode"
                    >
                        <Select
                            disabled={!isEditMode}
                            size="small"
                            className="jd-creation-input"                            
                            placeholder="Please Select"
                            options={WORK_OPTIONS}
                        />                          
                    </Form.Item>
                </div>

                <div className="triple-input-wrapper">
                    <Form.Item
                        name="hidectc"
                        className="jd-creation-field-item"
                        label="Hide CTC"
                    >
                        <Radio.Group
                            disabled={!isEditMode}
                            defaultValue={true}
                            className="jd-creation-radio-wrapper"
                            rules={[{ required: true, message: "Please select an option" }]}
                        >
                            <Radio
                                className="radio-option"
                                value= {true}
                            >
                                Yes
                            </Radio>
                            <Radio
                                className="radio-option"
                                value={false}
                            >
                                No
                            </Radio>
                        </Radio.Group>
                    </Form.Item>                    
                    <Form.Item
                        name="premiuminstitute_only"
                        className="jd-creation-field-item"
                        label="Premium Institue Only"
                    >
                        <Radio.Group
                            disabled={!isEditMode}
                            defaultValue={false}
                            className="jd-creation-radio-wrapper"
                            rules={[{ required: true, message: "Please select an option" }]}
                        >
                            <Radio
                                className="radio-option"
                                value= {true}
                            >
                                Yes
                            </Radio>
                            <Radio
                                className="radio-option"
                                value={false}
                            >
                                No
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        name="premiumjob"
                        className="jd-creation-field-item"
                        label="Premium Job"
                    >
                        <Radio.Group
                            disabled={!isEditMode}
                            defaultValue={false}
                            className="jd-creation-radio-wrapper"
                            rules={[{ required: true, message: "Please select an option" }]}
                        >
                            <Radio
                                className="radio-option"
                                value={true}
                            >
                                Yes
                            </Radio>
                            <Radio
                                className="radio-option"
                                value={false}
                            >
                                No
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                </div>

                <div className="triple-input-wrapper">
                    <Form.Item
                        name="diversity_only"
                        className="jd-creation-field-item"
                        label="Diversity Only"
                    >
                        <Radio.Group
                            disabled={!isEditMode}
                            defaultValue={false}
                            className="jd-creation-radio-wrapper"
                            rules={[{ required: true, message: "Please select an option" }]}
                        >
                            <Radio
                                className="radio-option"
                                value={true}
                            >
                                Yes
                            </Radio>
                            <Radio
                                className="radio-option"
                                value={false}
                            >
                                No
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        name="freshers_only"
                        className="jd-creation-field-item"
                        label="Freshers Only"
                    >
                        <Radio.Group
                            disabled={!isEditMode}
                            defaultValue={false}
                            className="jd-creation-radio-wrapper"
                            rules={[{ required: true, message: "Please select an option" }]}
                        >
                            <Radio
                                className="radio-option"
                                value={true}
                            >
                                Yes
                            </Radio>
                            <Radio
                                className="radio-option"
                                value={false}
                            >
                                No
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        name="interns_only"
                        className="jd-creation-field-item"
                        label="Interns Only"
                    >
                        <Radio.Group
                            disabled={!isEditMode}
                            className="jd-creation-radio-wrapper"
                            rules={[{ required: true, message: "Please select an option" }]}
                            defaultValue={false}
                        >
                            <Radio
                                className="radio-option"
                                value={true}
                            >
                                Yes
                            </Radio>
                            <Radio
                                className="radio-option"
                                value={false}
                            >
                               No
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                </div>
                <div className="triple-input-wrapper">
                    <Form.Item
                        name="hm_name"
                        className="jd-creation-field-item"
                        label="Hiring Manager Name"
                    >
                        <Input
                            disabled={!isEditMode}
                            className="jd-creation-input"
                        />
                    </Form.Item>
                    <Form.Item
                        name="hm_email"
                        className="jd-creation-field-item"
                        label="Hiring Manager E-Mail ID"
                    >
                        <Input
                            disabled={!isEditMode}
                            className="jd-creation-input"
                        />
                    </Form.Item>
                    <Form.Item
                        name="hm_number"
                        className="jd-creation-field-item"
                        label="Hiring Manager Contact Number"
                    >
                        <Input
                            disabled={!isEditMode}
                            className="jd-creation-input"
                        />
                    </Form.Item>
                </div>
               <div className="dual-input-wrapper">
                    <Form.Item
                        className="jd-creation-field-item"
                        label="BU Name"
                        name="bu_name"
                    >
                        <Input
                            disabled={!isEditMode}
                            className="jd-creation-input"
                        />
                    </Form.Item>
                    <Form.Item
                            name="proj_name"
                            className="jd-creation-field-item"
                            label="Project Name"
                        >
                            <Input
                                disabled={!isEditMode}
                                className="jd-creation-input"
                            />
                    </Form.Item>
                </div>                
                {
                   nujobsPost === false?
                    <>
                        <div className="dual-input-wrapper">
                        <Form.Item
                            name="allow_nonsuitable"
                            className="jd-creation-field-item"
                            label="Allow Non-Suitable Candidates"
                        >
                            <Radio.Group
                                disabled={!isEditMode}
                                defaultValue={false}
                                className="jd-creation-radio-wrapper"
                                required={false}
                            >
                                <Radio
                                    className="radio-option"
                                    value={true}
                                >
                                    Yes
                                </Radio>
                                <Radio
                                    className="radio-option"
                                    value={false}
                                >
                                    No
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            name="non_suitable_allow_reason"
                            className="jd-creation-field-item"
                            label="Reason for Allowing Non-Suitable Candidates"
                        >
                            <Input disabled={!isEditMode} className="jd-creation-input" />
                        </Form.Item>
                        </div>                   
                    </>
                    :<></>
                }              
        {value ? (
          <>
            <div className="dual-input-wrapper">
              <Form.Item
                name="postingdate"
                className="jd-creation-field-item"
                label="Posted On"
              >
                <Input disabled={true} className="jd-creation-input" />
              </Form.Item>
              <Form.Item
                name="postedby"
                className="jd-creation-field-item"
                label="Posted By"
              >
                <Input disabled={true} className="jd-creation-input" />
              </Form.Item>
            </div>
            <div className="dual-input-wrapper">
              <Form.Item
                name="updatedon"
                className="jd-creation-field-item"
                label="Last Updated"
              >
                <Input disabled={true} className="jd-creation-input" />
              </Form.Item>
              <Form.Item
                name="updatedby"
                className="jd-creation-field-item"
                label="Updated By"
              >
                <Input disabled={true} className="jd-creation-input" />
              </Form.Item>
            </div>
          </>
        ) : (
          <></>
        )}
                <Button
                    style={{ width: "100%", height: "40px", fontWeight: "600" }}
                    type="primary"
                    disabled={!isEditMode}
                    htmlType="submit"
                >
                    Submit Job Description
                </Button>
            </Form>
        </div>
    );
}
